.otp {
  :global(.ant-otp) {
    gap: var(--space-3);
  }

  :global(.ant-otp-input) {
    width: 40px;
    height: 40px;
    padding: 0;
    font-size: 15px;
    font-weight: var(--font-weight-medium);
    text-align: center;
    border-radius: 10px;
  }
}

.dash {
  display: inline-block;
  width: 12px;
  height: 1.5px;
  background: var(--text-primary);
}
